import { ClearOutlined } from '@ant-design/icons'
import { useQueryClient } from '@tanstack/react-query'
import { Button, message, Tooltip } from 'antd'

export function ResetCacheButton({ collapsed }: { collapsed?: boolean }) {
  const queryClient = useQueryClient()

  const handleClick = () => {
    void queryClient.resetQueries()
    void message.success('Cache cleared')
  }

  return (
    <Tooltip title={collapsed ? 'Reset cache' : undefined} placement="right">
      <Button
        icon={<ClearOutlined />}
        onClick={handleClick}
        aria-label="Reset cache"
        block
      >
        {collapsed ? null : 'Reset cache'}
      </Button>
    </Tooltip>
  )
}
